"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.reflect = exports.TimePeriod = void 0;
// NB this is a tradeoff that for now, we maintain ourself the types interface AND the JS declaration of them.
// this allow to do wrapping on top of the different libcore interfaces
var types_1 = require("../../generated/types");
exports.TimePeriod = {
    HOUR: 0,
    DAY: 1,
    WEEK: 2,
    MONTH: 3
};
// To make the above contract possible with current libcore bindings,
// we need to define the code below and build-up abstraction wrappings on top of the lower level bindings.
// We do this at runtime but ideally in the future, it will be at build time (generated code).
var reflect = function (declare) {
    var _a = (0, types_1.reflectSpecifics)(declare).reduce(function (all, extra) { return ({
        AccountMethods: __assign(__assign({}, all.AccountMethods), (extra && extra.AccountMethods)),
        OperationMethods: __assign(__assign({}, all.OperationMethods), (extra && extra.OperationMethods))
    }); }, { AccountMethods: {}, OperationMethods: {} }), AccountMethods = _a.AccountMethods, OperationMethods = _a.OperationMethods;
    declare("WalletPool", {
        statics: {
            newInstance: {
                params: [
                    null,
                    null,
                    "HttpClient",
                    "WebSocketClient",
                    "PathResolver",
                    "LogPrinter",
                    "ThreadDispatcher",
                    "RandomNumberGenerator",
                    "DatabaseBackend",
                    "DynamicObject",
                ],
                returns: "WalletPool"
            }
        },
        methods: {
            freshResetAll: {},
            changePassword: {},
            getName: {},
            updateWalletConfig: {
                params: [null, "DynamicObject"]
            },
            getWallet: {
                returns: "Wallet"
            },
            getCurrency: {
                returns: "Currency"
            },
            createWallet: {
                params: [null, "Currency", "DynamicObject"],
                returns: "Wallet"
            }
        }
    });
    declare("Wallet", {
        methods: {
            getAccountCreationInfo: {
                returns: "AccountCreationInfo"
            },
            getNextAccountCreationInfo: {
                returns: "AccountCreationInfo"
            },
            newAccountWithInfo: {
                params: ["AccountCreationInfo"],
                returns: "Account"
            },
            getCurrency: {
                returns: "Currency"
            },
            getAccount: {
                returns: "Account"
            },
            getExtendedKeyAccountCreationInfo: {
                returns: "ExtendedKeyAccountCreationInfo"
            },
            newAccountWithExtendedKeyInfo: {
                params: ["ExtendedKeyAccountCreationInfo"],
                returns: "Account"
            }
        }
    });
    declare("Account", {
        methods: __assign(__assign({}, AccountMethods), { getBalance: {
                returns: "Amount"
            }, getBalanceHistory: {
                returns: ["Amount"]
            }, getLastBlock: {
                returns: "Block"
            }, getFreshPublicAddresses: {
                returns: ["Address"]
            }, getRestoreKey: {}, synchronize: {
                returns: "EventBus"
            }, queryOperations: {
                returns: "OperationQuery"
            } })
    });
    declare("Operation", {
        methods: __assign(__assign({}, OperationMethods), { getDate: {}, getOperationType: {}, getAmount: {
                returns: "Amount"
            }, getFees: {
                returns: "Amount"
            }, getBlockHeight: {}, getRecipients: {}, getSelfRecipients: {}, getSenders: {} })
    });
    declare("Currency", {
        njsUsesPlainObject: true,
        methods: {
            getBitcoinLikeNetworkParameters: {
                returns: "BitcoinLikeNetworkParameters",
                njsField: "bitcoinLikeNetworkParameters"
            }
        }
    });
    declare("BigInt", {
        statics: {
            fromIntegerString: {
                njsBuggyMethodIsNotStatic: function () { return ["", 0, "."]; },
                returns: "BigInt"
            }
        },
        methods: {
            toString: {}
        }
    });
    declare("Amount", {
        statics: {
            fromHex: {
                params: ["Currency"],
                returns: "Amount",
                njsBuggyMethodIsNotStatic: true
            }
        },
        methods: {
            toBigInt: {
                returns: "BigInt"
            }
        }
    });
    declare("Block", {
        njsUsesPlainObject: true,
        methods: {
            getHeight: {
                njsField: "height"
            }
        }
    });
    declare("DerivationPath", {
        methods: {
            toString: {},
            isNull: {}
        }
    });
    declare("Address", {
        statics: {
            isValid: {
                params: [null, "Currency"],
                njsBuggyMethodIsNotStatic: true
            }
        },
        methods: {
            toString: {},
            getDerivationPath: {}
        }
    });
    declare("OperationQuery", {
        methods: {
            limit: {},
            offset: {},
            partial: {},
            complete: {},
            addOrder: {},
            execute: {
                returns: ["Operation"]
            }
        }
    });
    declare("AccountCreationInfo", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, null, ["hex"], ["hex"]],
                returns: "AccountCreationInfo",
                njsInstanciateClass: [
                    {
                        index: 0,
                        owners: 1,
                        derivations: 2,
                        publicKeys: 3,
                        chainCodes: 4
                    },
                ]
            }
        },
        methods: {
            getDerivations: {
                njsField: "derivations"
            },
            getChainCodes: {
                njsField: "chainCodes",
                returns: ["hex"]
            },
            getPublicKeys: {
                njsField: "publicKeys",
                returns: ["hex"]
            },
            getOwners: {
                njsField: "owners"
            },
            getIndex: {
                njsField: "index"
            }
        }
    });
    declare("ExtendedKeyAccountCreationInfo", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                returns: "ExtendedKeyAccountCreationInfo",
                njsInstanciateClass: [
                    {
                        index: 0,
                        owners: 1,
                        derivations: 2,
                        extendedKeys: 3
                    },
                ]
            }
        },
        methods: {
            getIndex: {
                njsField: "index"
            },
            getExtendedKeys: {
                njsField: "extendedKeys"
            },
            getOwners: {
                njsField: "owners"
            },
            getDerivations: {
                njsField: "derivations"
            }
        }
    });
    declare("DynamicObject", {
        statics: {
            flush: {},
            newInstance: {
                returns: "DynamicObject",
                njsInstanciateClass: []
            }
        },
        methods: {
            putBoolean: {},
            putString: {},
            putInt: {}
        }
    });
    declare("SerialContext", {});
    declare("ThreadDispatcher", {
        statics: {
            newInstance: {
                returns: "ThreadDispatcher"
            }
        },
        methods: {
            getMainExecutionContext: {
                nodejsNotAvailable: true,
                returns: "SerialContext"
            }
        }
    });
    declare("EventBus", {
        methods: {
            subscribe: {
                params: ["SerialContext", "EventReceiver"]
            }
        }
    });
    declare("EventReceiver", {
        statics: {
            newInstance: {
                returns: "EventReceiver"
            }
        }
    });
    declare("HttpClient", {
        statics: {
            newInstance: {
                returns: "HttpClient"
            },
            flush: {}
        }
    });
    declare("WebSocketClient", {
        statics: {
            newInstance: {
                returns: "WebSocketClient"
            },
            flush: {}
        }
    });
    declare("PathResolver", {
        statics: {
            newInstance: {
                returns: "PathResolver"
            },
            flush: {}
        }
    });
    declare("LogPrinter", {
        statics: {
            newInstance: {
                returns: "LogPrinter"
            },
            flush: {}
        }
    });
    declare("RandomNumberGenerator", {
        statics: {
            newInstance: {
                returns: "RandomNumberGenerator"
            },
            flush: {}
        }
    });
    declare("DatabaseBackend", {
        statics: {
            flush: {},
            getSqlite3Backend: {
                returns: "DatabaseBackend"
            }
        }
    });
    declare("LedgerCore", {
        statics: {
            getStringVersion: {
                njsBuggyMethodIsNotStatic: true
            },
            getIntVersion: {
                njsBuggyMethodIsNotStatic: true
            }
        }
    });
};
exports.reflect = reflect;
//# sourceMappingURL=index.js.map